import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  getHoldingWithApartmentSchemaWithAdditionalFields,
  holdingWithApartmentSchema,
} from "./holding-with-apartment";
import {
  getLeaseWithApartmentSchemaWithAdditionalFields,
  leaseWithApartmentSchema,
} from "./lease-with-apartment";
import {
  getOrganizationSchemaAdditionalFields,
  organizationSchema,
} from "./organization";
import {
  getSubletWithApartmentSchemaWithAdditionalFields,
  subletWithHoldingOrLeaseAndApartmentSchema,
} from "./sublet-with-holding-or-lease-and-apartment";

export const organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema =
  organizationSchema.extend({
    holdings: z.array(holdingWithApartmentSchema),
    leases: z.array(leaseWithApartmentSchema),
    sublets: z.array(subletWithHoldingOrLeaseAndApartmentSchema),
    issueCount: z.number().int().nonnegative().default(0),
  });

export type OrganizationWithHoldingsAndLeasesAndSubletsAndApartment = z.infer<
  typeof organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema
>;

export function getOrganizationWithHoldingsAndLeasesAndSubletsAndApartmentSchemaWithAdditionalFields(additionalFields: {
  organization: typeof additionalDataSchema;
  holding: typeof additionalDataSchema;
  lease: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  apartment: typeof additionalDataSchema;
}): typeof organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema {
  return getOrganizationSchemaAdditionalFields(additionalFields)
    .merge(organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema)
    .extend({
      holdings: z.array(
        getHoldingWithApartmentSchemaWithAdditionalFields(additionalFields),
      ),
      leases: z.array(
        getLeaseWithApartmentSchemaWithAdditionalFields(additionalFields),
      ),
      sublets: z.array(
        getSubletWithApartmentSchemaWithAdditionalFields(additionalFields),
      ),
    });
}
